@if (isVisible) {
  <div class="dynamicPlacemark"
    [style.top.px]="top"
    [style.left.px]="left"
    [style.transform]="scale"
    >
    <div class="space"></div>
    @if (noContentToDisplay) {
      <div class="no-data-message">
        No data is available
      </div>
    }
    @if (!noContentToDisplay) {
      <table class="table" (mouseleave)="mouseLeave()" (mouseenter)="mouseEnter()">
        <caption></caption>
        <thead>
          @if (tableConf.showTableHeader) {
            <tr class="header tableRow">
              <td [attr.colspan]="visibleColumnCount" #tableHeaderName insTooltip [cfg]="getToolTipConf(tableHeaderName, tableConf.tableHeaderName)">{{tableConf.tableHeaderName}}</td>
            </tr>
          }
          @if (tableConf.showColumnTitle) {
            <tr class="columnTitle tableRow">
              @for (col of tableConf.colDef; track col) {
                @if (col.visible) {
                  <th id="colColumnBgColor"
                    [style.background-color]="'#'+ col.columnBgColor"
                    [style.color]="col.columnTextColor"
                    #columnHeader insTooltip [cfg]="getToolTipConf(columnHeader, col.columnName)">
                    {{col.columnName}}
                  </th>
                }
              }
            </tr>
          }
        </thead>
        <perfect-scrollbar class="scrollbar" [style.height.px]="tableHeight">
          <tbody>
            @for (item of rowData; track item) {
              <tr class="tableRow">
                @for (col of tableConf.colDef; track col) {
                  @if (col.visible) {
                    <td [style.background-color]="'#'+ col.columnBgColor"
                      [style.color]="col.columnTextColor"
                      #columnCell insTooltip [cfg]="getToolTipConf(columnCell, item[col.field])">
                      {{item[col.field]}}
                    </td>
                  }
                }
              </tr>
            }
          </tbody>
        </perfect-scrollbar>
      </table>
    }
  </div>
}
